import store from "@/store";
import router from "../router/index";

// import { getToken } from "../utils/token";
var socket = null;//实例对象
var lockReconnect = false; //是否真正建立连接
var timeout = 20 * 1000; //20秒一次心跳
var timeoutObj = null; //心跳倒计时
var serverTimeoutObj = null; //服务心跳倒计时
var serverTimeoutNum = 0; //重连次数
var timeoutnum = null; //断开 重连倒计时
var socketStatus=false
var wsUrl=null;
var Authorization =window.sessionStorage.getItem('token')
//  wsUrl='ws://124.222.224.186:8800';
const initWebSocket = async (thesis_id,user_id,group_id) => {
  if ("WebSocket" in window) {
    if(thesis_id&&user_id&&group_id){
      socketStatus=true
      let devApi=process.env.VUE_APP_BASE_URL
      const wssUrl=  window.location.origin.replace("https", "wss")
      wsUrl = (devApi?devApi:wssUrl) + `/websocket/db/user?thesis_id=${thesis_id}&u_id=${user_id}&db_group_id=${group_id}&sid=${store.state.id||''}&access_token=${Authorization}`;
      // wsUrl =process.env.VUE_APP_BASE_URL+`/websocket/db/user?thesis_id=${thesis_id}&u_id=${user_id}&db_group_id=${group_id}&sid=${store.state.id||''}&access_token=${Authorization}`;
    }
    if(wsUrl){socket = new WebSocket(wsUrl);}
    socket.onerror = webSocketOnError;
    socket.onmessage = webSocketOnMessage;
    socket.onclose = closeWebsocket;
    socket.onopen = openWebsocket;
  } else {
    window.$root.$message({
      showClose: true,
      message: '您的浏览器不支持websocket，请更换Chrome或者Firefox',
      type: "error",
      onClose: () => {},
    });
  }
}

//建立连接
const openWebsocket = (e) => {
  if(serverTimeoutNum){
    console.log('重连成功');
  }
  serverTimeoutNum=0
  start();
}

const start = ()=> {
  if(!socketStatus){
    return
  }
  //开启心跳
  timeoutObj && clearTimeout(timeoutObj);
  serverTimeoutObj && clearTimeout(serverTimeoutObj);
  timeoutObj = setTimeout(function() {
    //这里发送一个心跳，后端收到后，返回一个心跳消息
    if (socket.readyState == 1) {
      //如果连接正常
      socket.send(JSON.stringify({messageType:-2,speakerId:store.state.user.userId,content:'ping'}));
    } else {
      //否则重连
      reconnect();
    }
    serverTimeoutObj = setTimeout(function() {
      //超时
      socket.close();
    }, timeout);
  }, timeout);
}

//重新连接
const reconnect =() => {
  if(!socketStatus){
    return
  }
  if (lockReconnect) {
    return;
  }
  lockReconnect = true;
  serverTimeoutNum++
      console.log('连接断开正在尝试重连：'+serverTimeoutNum);
  //没连接上会一直重连，设置延迟避免请求过多
  timeoutnum && clearTimeout(timeoutnum);
  timeoutnum = setTimeout(function() {
    //新连接
    initWebSocket();
    lockReconnect = false;
  }, 1000);
}

//重置心跳
const reset =() => {
  //清除时间
  clearTimeout(timeoutObj);
  clearTimeout(serverTimeoutObj);
  //重启心跳
  start();
}

const sendWebsocket =(e) =>{
  return new Promise((resolve, reject) => {
    if (socket.readyState == 1) {
      socket.send(JSON.stringify(e));
      resolve()
    } else {
      reconnect();
      reject('网络连接断开，正在重新连接，请稍后！')
    }
  })
}

const webSocketOnError =(e) => {
  // initWebSocket();
  reconnect();

}

//服务器返回的数据
const webSocketOnMessage=(e) => {
  // //判断是否登录
  // if (getToken()) {
    //window自定义事件
    let data=JSON.parse(e?.data);
    const t=data.messageType
    if(t==-1){
      window.$root.$message({
        showClose: true,
        message: data.content||'系统异常',
        type: "error",
        onClose: () => {},
      });
    }else if(t==0){
      window.$root.$message({
        showClose: true,
        message: '未登录或状态失效',
        type: "error",
        onClose: () => {
            router.push({ path: "/login" });
        },
      });
    }else{
      window.dispatchEvent(
        new CustomEvent("onmessageWS",
          {
            detail:data,
          }
        )
      );
    }

  // }
  reset();
}

const closeWebsocket=(e) => {
  reconnect();
}

//断开连接
const close =() => {
//WebSocket对象也有发送和关闭的两个方法，只需要在自定义方法中分别调用send()和close()即可实现。
  socket.close();
  socketStatus=false
  wsUrl=null
  clearTimeout(timeoutObj);
  clearTimeout(serverTimeoutObj);
}

//监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接
window.onbeforeunload = function () {
  close()
}
//具体问题具体分析,把需要用到的方法暴露出去
export default { initWebSocket, sendWebsocket, webSocketOnMessage, close };
